<template>
  <div class="search-nav-start-end flex gap-2 w-full xl:w-auto">
    <span v-if="label" class="title">{{ label }}</span>
    <div class="flex-1 flex flex-wrap items-center gap-2">
      <date-selector v-model="sDate" :readonly="readonly" placeholder="선택" @change="onChangeData" class="w-full xl:w-32" />
      <span>~</span>
      <date-selector v-model="eDate" :readonly="readonly" placeholder="선택" @change="onChangeData" class="flex-1 xl:w-32" />
    </div>
  </div>
</template>

<script>
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import DateSelector from "@/components/selector/DateSelector";
export default {
  name: "SearchNavStartEnd",
  components: {
    DateSelector,
    SearchNavItemSelect,
  },
  props: {
    label: {
      default: "대상기간",
      type: String,
    },
    value: Object | String,
    readonly: Boolean,
  },
  watch: {
    value(value) {
      const { sDate, eDate } = value;
      this.sDate = sDate;
      this.eDate = eDate;
    },
  },
  data() {
    return {
      sDate: "",
      eDate: "",
    };
  },
  mounted() {
    if (!this.value || !this.value.sDate) {
      this.$emit("input", { sDate: this.sDate, eDate: this.eDate });
    }
  },
  methods: {
    onChangeData() {
      this.$emit("input", { sDate: this.sDate, eDate: this.eDate });
      this.$emit("change", { sDate: this.sDate, eDate: this.eDate });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  width: 114px;

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;
}
</style>
